<script setup>
import { computed } from 'vue';

const props = defineProps({
  grid: {
    type: Object,
    default: undefined,
  },
  mobileDefaultGrid: {
    type: Array,
    default: () => [1, 14],
  },
  tabletDefaultGrid: {
    type: Array,
    default: () => [1, 10],
  },
  desktopDefaultGrid: {
    type: Array,
    default: () => [2, 20],
  },
  contentClass: {
    type: [String, Object, Array],
    default: '',
  },
});

const getGridValue = (field, fallbackGrid) => {
  const gridValue = field?.fields?.phrase?.value;
  const [start, span] = `${gridValue || fallbackGrid.join('_')}`.split('_').map(Number);

  return Number.isFinite(start) && Number.isFinite(span) ? [start, span] : fallbackGrid;
};

const gridValues = computed(() => {
  const desktopGrid = getGridValue(props.grid?.fields?.desktopGrid, props.desktopDefaultGrid);
  const mobileGrid = getGridValue(
    props.grid?.fields?.mobileGrid,
    props.grid?.fields?.desktopGrid?.fields?.phrase?.value ? desktopGrid : props.mobileDefaultGrid
  );

  return { mobileGrid, desktopGrid };
});

const rootClass = computed(() => {
  return ['e-content-grid'];
});

const contentClasses = computed(() => {
  return ['e-content-grid__content', props.contentClass];
});

const contentStyle = computed(() => {
  const { mobileGrid, desktopGrid } = gridValues.value;
  return {
    '--grid-mobile-start': mobileGrid[0] + 1,
    '--grid-mobile-span': mobileGrid[1],
    '--grid-desktop-start': desktopGrid[0] + 1,
    '--grid-desktop-span': desktopGrid[1],
  };
});
</script>

<template>
  <div :class="rootClass">
    <div :class="contentClasses" :style="contentStyle">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';

.e-content-grid {
  max-width: calc(1440px * 1.2);
  margin: 0 auto;
  display: grid;
  // 移动端样式：< 880px，16 列栅格
  grid-template-columns: repeat(16, 1fr);
  height: inherit;

  // PC 端样式：>= 880px，24 列栅格
  @include tablet-landscape {
    grid-template-columns: repeat(24, 1fr);
  }

  &__content {
    height: inherit;
    grid-column-start: var(--grid-mobile-start);
    grid-column-end: span var(--grid-mobile-span);

    @include tablet-landscape {
      grid-column-start: var(--grid-desktop-start);
      grid-column-end: span var(--grid-desktop-span);
    }
  }
}
</style>
